import { render } from "./BlockText.vue?vue&type=template&id=2396a494"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"

import "./BlockText.vue?vue&type=style&index=0&id=2396a494&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__